import { render, staticRenderFns } from "./IndicatorComponent.vue?vue&type=template&id=5588b002&scoped=true"
import script from "./IndicatorComponent.vue?vue&type=script&lang=js"
export * from "./IndicatorComponent.vue?vue&type=script&lang=js"
import style0 from "./IndicatorComponent.vue?vue&type=style&index=0&id=5588b002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588b002",
  null
  
)

export default component.exports